import { observer } from 'mobx-react-lite';
import { LayoutChangeEvent, View } from 'react-native';
import { useStore } from '../../contexts/StoreContext';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { ButtonProps } from '@photosi/rn-components/buttons/button/Button.types';
import { QuaternaryActionButton } from 'src/editor-v3/components/buttons/quaternary-action-button/QuaternaryActionButton';
import { BUTTON_LAYOUTS, BUTTON_SIZES } from 'src/editor-v3/components/buttons/button/Button.constants';
import { ACTION_BUTTON_MODE } from 'src/editor-v3/components/buttons/quaternary-action-button/QuaternaryActionButton.types';
import { styles } from './ImageMissingPlaceholder.styles';
import { useDebounceCallback } from 'src/hooks/useDebounceCallback';
import { useState } from 'react';

type ImagePlaceholderProps = {
  // Shows text info on desktop
  showText?: boolean;
} & ButtonProps;

export const ImageMissingPlaceholder = observer(
  ({ style, innerStyle, focusStyle, showText = false, disabled = false, ...buttonProps }: ImagePlaceholderProps) => {
    const { i18n } = useStore();
    const [isSmall, setIsSmall] = useState(false);

    const onLayoutHandler = useDebounceCallback((e: LayoutChangeEvent) => {
      setIsSmall(Number(e.nativeEvent.layout.width.toFixed(2)) < 180);
    }, 10);

    return (
      <View style={styles.container} onLayout={onLayoutHandler}>
        <View>
          <QuaternaryActionButton
            mode={showText ? ACTION_BUTTON_MODE.LABEL : ACTION_BUTTON_MODE.ICON_ONLY}
            focusStyle={styles.focusStyle}
            textNumberOfLines={showText ? (isSmall ? 2 : 1) : undefined}
            size={isSmall ? BUTTON_SIZES.SMALL : BUTTON_SIZES.REGULAR}
            text={i18n.t('upload:add')}
            iconName={ICON_NAMES.AddPhoto}
            layout={isSmall ? BUTTON_LAYOUTS.FILL : BUTTON_LAYOUTS.CENTER}
            {...buttonProps}
          />
        </View>
      </View>
    );
  },
);

ImageMissingPlaceholder.displayName = 'ImageMissingPlaceholder';
